import axios from "../axiosConfig";
import {
    ENDPOINT_IP_WHITELIST,
    ENDPOINT_IP_WHITELIST_ADD,
    ENDPOINT_IP_WHITELIST_REMOVE,
    ENDPOINT_IP_BANNED,
    ENDPOINT_IP_BANNED_UNBAN,
    ENDPOINT_IP_BANNED_ADD
} from "../../constants";

export function retrieveWhitelist(): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
        axios.get(ENDPOINT_IP_WHITELIST, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}

export function retrieveBannedList(): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
        axios.get(ENDPOINT_IP_BANNED, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}

export function addToWhitelist(ip: string, description?: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_IP_WHITELIST_ADD, {
            ip: ip,
            description: description
        }, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}

export function removeFromWhitelist(ip: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_IP_WHITELIST_REMOVE, {
            ip: ip
        }, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}

export function unbanIP(ip: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_IP_BANNED_UNBAN, {
            ip: ip
        }, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}

export function banIP(ip: string, reason: string, durationHours: number, description?: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_IP_BANNED_ADD, {
            ip: ip,
            reason: reason,
            durationHours: durationHours,
            description: description
        }, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}